import { request } from '@/shared/api/request'

export const getDictsVersion = () => {
	return request({ url: 'dict/getDictsVersion', method: 'GET' })
}
